import * as React from 'react';
import { ControlIcons } from 'owa-control-icons';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { observer } from 'mobx-react';

const searchBoxPillWellStyles = require('./SearchBoxPillWell.scss');
export interface FilePillProps {
    fileName: string;
    isSelected: boolean;
}

@observer
export default class FilePill extends React.Component<FilePillProps, {}> {
    private pillDiv: HTMLElement;

    componentDidUpdate() {
        if (this.props.isSelected) {
            this.pillDiv.focus();
        }
    }

    render(): any {
        const fileName = this.props.fileName;
        return (
            <div
                className={searchBoxPillWellStyles.filePill}
                ref={ref => (this.pillDiv = ref)}
                tabIndex={-1}>
                <Icon
                    iconName={ControlIcons.Attach}
                    className={searchBoxPillWellStyles.attachIcon}
                />
                <div className={searchBoxPillWellStyles.filePillNameText}>{fileName}</div>
            </div>
        );
    }
}
